import * as APITypes from "../../../../api/cur8/generated-types/v1/Api";
import { makePath } from "../../../../api/url";
import { getJSON, postJSON } from "../../request";
import { APIContext } from "../../types";

export type GdprExportAPI = ReturnType<typeof createGdprExportAPI>;

export function createGdprExportAPI({ buildURL, fetchJSON }: APIContext) {
  return {
    fetchLatestGdprExport({ patientId }: { patientId: string }) {
      const path = makePath(["api", "v1", "patient", patientId, "gdpr"]);
      const url = buildURL(path);
      const request = getJSON(url);
      return fetchJSON<APITypes.GdprExport>(request);
    },
    createGdprExport({ patientId }: { patientId: string }) {
      const path = makePath(["api", "v1", "patient", patientId, "gdpr"]);
      const url = buildURL(path);
      const request = postJSON(url, {});
      return fetchJSON<void>(request);
    },
  };
}
